import { RequireChildrenFor } from "@omni/types/components/utils/children.types";
import { Mapped } from "@omni/utils/context/mapped.context";

import { useBannerSliderContext } from "../../context/bannerSlider.context";

const Base = ({ children }: RequireChildrenFor<{}>) => {
    const { slides } = useBannerSliderContext();

    if (slides.length < 2) {
        return null;
    }

    return <Mapped array={slides}>{children}</Mapped>;
};

export { Base };
